export default __webpack_public_path__ + "static/media/320px-Flag_of_Galicia.svg.805802ce.png";